export default "__VITE_ASSET__iEyCT5L5__"